const SecuritySection = () => {
  return (
    <section className="grid grid-cols-2 items-center px-20 py-20" data-cy="security-section">
      <div className="h-96 rounded-2xl bg-sandstone-500" />
      <div className="text-center text-7xl font-bold">
        Your health data, protected
      </div>
    </section>
  );
};

export default SecuritySection;
